import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { rawMaximumEmotionValue } from "motw_core/Repositories/EmotionRepository";
import type { Emotion } from "source/app/domain/Emotions/Emotion";
import { UpdateKeyValueAsync } from "source/app/infrastructure/Data/KeyValues/UpdateKeyValue";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { Emotions } from "../../../../domain/Emotions/Emotions";
import { AreYouSure } from "../../../../services/Shared/RenderSwal/RenderSwal";
import { Sounds } from "../../../../services/Sound/Sounds";
import UI from "../../../../services/UI/UI";

export const HandleEmotionSelectedLocallyAsync = async (
    emotion: Emotion,
    isConfirmed = false
) => {
    if (emotion === Emotions.IntegratedPlus && !isConfirmed) {
        AreYouSure(
            `Record I+ max score? This records raw score ${rawMaximumEmotionValue} and caps attainment at 100%.`,
            () => {
                void HandleEmotionSelectedLocallyAsync(emotion, true);
            },
            `70px`
        );
        return;
    }

    UI.ScrollToDiv(`#scrollTarget_keyValueLogs`);
    const currentEmotion = Emotions.Current;

    if (emotion.IsHigherThan(currentEmotion)) {
        Sounds.bellLong.Play();
    } else {
        Sounds.bellDingDong.Play();
    }

    await WithAnimatedProgressBarAsync(() =>
        UpdateKeyValueAsync(
            ESharedFunction.EmotionSelector_character,
            emotion.character
        )
    );
};
